export const GET_COURSE = 'GetCourse';
export const GET_COURSES = 'GetCourses';
